/**
 * Inline pill tab toggle — same look as Expenses' "מפורט / מסכם" toggle.
 *
 * Container is a thin grey-tinted rounded box; the active button gets a white
 * background + small shadow; inactive buttons are secondary-text on hover.
 */
interface TabPillProps<K extends string> {
  value: K;
  onChange: (value: K) => void;
  options: Array<{ value: K; label: string }>;
}

export function TabPill<K extends string>({ value, onChange, options }: TabPillProps<K>) {
  return (
    <div className="inline-flex p-1 bg-border/60 rounded">
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`px-4 py-1.5 text-small font-medium rounded transition-colors ${
            value === opt.value
              ? 'bg-white text-main-text shadow-sm'
              : 'text-secondary-text hover:text-main-text'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
